module.exports = __webpack_public_path__ + "static/media/author-spot1.93fae92b.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/author-spot1.png
// module id = 1668
// module chunks = 1